import React from 'react';
import { UserIcon } from '@heroicons/react/24/outline';

/**
 * «Puede ser un filtro de llamadas. Habla.»
 *
 * Un filtro —el de iOS, el de Android— suena **exactamente igual que un buzón**:
 * una locución. La diferencia es que detrás hay una persona escuchando lo que
 * dices para decidir si coge. Si nadie habla, no coge.
 *
 * 🔴 **Sale en cuanto el AMD dice «máquina», no cuando se confirma el filtro.**
 * Medido en producción el 25/09/2026 con una llamada perdida: descuelgan en el
 * segundo 0, el AMD dicta en el 4,4, y el aviso salía en el **12,4** —después de
 * esperar ocho segundos al pitido para estar seguros—. El filtro llevaba once
 * segundos oyendo silencio y colgó él.
 *
 * Así que ahora se avisa con la duda encima, y el texto lo dice. El coste de
 * equivocarse es asimétrico: si era un buzón, el gestor habla unos segundos contra
 * una locución y no pasa nada; si era un filtro y calla, se pierde a alguien
 * localizable **y** se programa un reintento que se encontrará el mismo filtro.
 */
const ScreeningNotice = ({ screening, compact = false }) => {
  if (!screening) return null;

  if (compact) {
    return (
      <span className='inline-flex items-center gap-1 rounded-lg bg-amber-100 px-2 py-0.5 text-xs font-medium text-amber-900'>
        <UserIcon className='h-3 w-3' aria-hidden='true' />
        Di tu nombre
      </span>
    );
  }

  return (
    <div className='mb-4 rounded-lg border border-amber-200 bg-amber-50 p-4'>
      <div className='flex items-start gap-3'>
        <UserIcon className='mt-0.5 h-5 w-5 shrink-0 text-amber-600' aria-hidden='true' />
        <div>
          {/*
            El título es una instrucción, no un diagnóstico. Lo que el gestor tiene
            que hacer es lo mismo en los dos casos, así que decirle «esto es un
            filtro» —cuando la mayoría de las veces será un buzón— solo le haría
            dudar en los segundos que no puede gastar dudando.
          */}
          <p className='font-medium text-amber-900'>Habla ahora: di tu nombre</p>
          <p className='text-sm text-amber-800'>
            Suena a contestador, pero puede ser un filtro de llamadas con una persona
            esperando a oírte para pasarte. Di quién eres y de parte de quién llamas.
            Si era un buzón, no pasa nada.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ScreeningNotice;
